import type { FieldErrors } from '@/lib/validationErrors';
import { getFieldError } from '@/lib/validationErrors';

export function FieldError({
  errors,
  field,
  id,
}: { errors?: FieldErrors; field: string; id?: string }) {
  const message = getFieldError(errors, field);
  if (!message) return null;
  return (
    <p id={id ?? `${field}-error`} role="alert" className="text-sm text-destructive">
      {message}
    </p>
  );
}

export function fieldErrorProps(errors: FieldErrors | undefined, field: string) {
  const hasError = Boolean(getFieldError(errors, field));
  return hasError ? { 'aria-invalid': true as const, 'aria-describedby': `${field}-error` } : {};
}
